import React from 'react';
import {View} from 'react-native';
import {GetRequestResponsePayload} from '../../../../../../shared/models/api';
import {NamedStyles, useStyles} from '../../../../../../shared/hooks/styles';
import {Text} from '../../../../../../shared/components/text';
import {Links} from './links';
import {DeviceSize} from '../../../../../../shared/theme/helpers';
import {useIsDesktop} from '../../../../../../shared/hooks/useIsDesktop';
import {Html} from '../../../../../../shared/components/html';
import {MixedTextToHtmlOnly} from '../../../../../../shared/utils/text';

export const RequestBlock = ({
  request,
  styles,
}: {
  request: GetRequestResponsePayload | null;
  styles: NamedStyles<any>;
}) => {
  const isDesktop = useIsDesktop();
  const innerStyles = useStyles(({theme, mediaOnly}) => ({
    requestContainer: {
      paddingVertical: 8,
      width: '100%',
      minHeight: 42,
    },
    textContainer: {
      marginTop: 25,
    },
    label: {
      ...theme.fonts.h6,
      marginBottom: 6,
    },
    text: mediaOnly(DeviceSize.desktop, theme.fonts.h5Light),
  }));

  return (
    <>
      <View style={innerStyles.requestContainer}>
        <Text style={[innerStyles.label]}>Тема обращения</Text>
        <Text type={isDesktop ? 'h5Light' : undefined} testID='topic-request-title'>
          {request?.topic}
        </Text>
      </View>
      <View style={[innerStyles.requestContainer, innerStyles.textContainer]} testID='topic-request-body'>
        <Text style={[innerStyles.label]}>Сообщение</Text>
        <Html content={MixedTextToHtmlOnly(request?.text)} testID='topic-request-text' />
      </View>
      <Links type='appeal' request={request} styles={styles} />
    </>
  );
};
